import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalType, NonPersistedModalName } from '@shared/models/modal.model';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { EventManager } from '@app/shared/utils/event-manager';
import { LoggerService } from '@app/shared/services/logger.service';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FormValidatorsService } from '@app/shared/services/form-validators.service';
import { UserRepository } from '@app/shared/state/user/user.repository';
import { SharedModule } from '@app/shared/shared.module';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { DividerComponent } from '@app/shared/components/divider/divider.component';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-account-deletion-step2',
  templateUrl: './account-deletion-step2.component.html',
  styleUrls: ['./account-deletion.component.scss'],
  standalone: true,
  imports: [SharedModule, ButtonComponent, DividerComponent, ReactiveFormsModule],
})
// eslint-disable-next-line
export class AccountDeletionStep2 implements OnInit {
  logger = inject(LoggerService);
  private fb = inject(UntypedFormBuilder);
  private validators = inject(FormValidatorsService);
  private userRepo = inject(UserRepository);
  private eventManager = inject(EventManager);
  info = inject<Modal>(MAT_DIALOG_DATA);

  accountDeletionForm: UntypedFormGroup;
  userName: string;

  constructor() {
    this.createAccountDeletionForm();
  }

  ngOnInit() {
    this.userName = this.userRepo.getNickName();
  }

  get invalidUserName() {
    return this.accountDeletionForm.get('userNickname').invalid && this.accountDeletionForm.get('userNickname').touched;
  }

  private createAccountDeletionForm() {
    this.accountDeletionForm = this.fb.group({
      userNickname: ['', [Validators.required, this.validators.userNameValidator]],
    });
  }

  private checkAllRequiredFormFields(currentForm: UntypedFormGroup) {
    if (currentForm.invalid) {
      return Object.values(currentForm.controls).forEach((control) => {
        control.markAsTouched();
      });
    } else {
      this.closeModal();
      this.eventManager.openModal(
        new Modal(NonPersistedModalName.AccountDeletionStep3, ModalType.View, this.info.data, 'default')
      );
    }
  }

  checkForm() {
    this.checkAllRequiredFormFields(this.accountDeletionForm);
  }

  closeModal() {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.AccountDeletionStep2, ModalType.View));
  }
}
